var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanFillType1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_3",
    "data-name": "Camada 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.38 238.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff9700;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.84,199.03c25.34-53.07.99-83.56-31.02-105.79C83.04,62.82,98.66,0,98.66,0c-47.39,42.37-23.4,88.68-7.33,120.61,9.28,18.45,2.93,35.99-20.23,38.47-46.11,4.95-38.28-72.98-38.28-72.98-52.92,62.35-26.87,108.64-23.09,113.03,0,0,22.81,39.37,74.45,39.45,55.77.08,73.66-39.55,73.66-39.55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFillType1);
export default __webpack_public_path__ + "static/media/plan-fill-type-1.8afbd83dde71bfaaa39e859f19982404.svg";
export { ForwardRef as ReactComponent };